import React, { Component } from 'react'
import { TableCell, TableRow, IconButton } from "@mui/material";
import { Col, Container, Row, Form } from 'react-bootstrap';
import axios from "axios";
import Swal from "sweetalert2";
import PhoneClinicGrid from '../../Components/PhoneClinicGrid';

import AmountInput from '../../Components/AmountInput';
import FormCard from './shared/FormCard';
import OwnEntityField from '../../Components/OwnEntityField';
import { defaultOwnId, myEntities } from '../../helper/identity';

const OWN_SCREEN = '/admin/vendor-setup';
// Vendors belong to a shop or a warehouse: the kind the signed-in user has for this screen.
const OWN_KIND = () => (myEntities('shop', OWN_SCREEN).length ? 'shop' : (myEntities('warehouse', OWN_SCREEN).length ? 'warehouse' : (localStorage.getItem('PC_GRP_ID') === '3' ? 'warehouse' : 'shop')));
class VendorSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The working shop (Phase 2): the list shows it and new records are saved to it.
            OWN_ID: defaultOwnId(OWN_KIND(), OWN_SCREEN),
            InventoryList: [],

            PC_VEN_ID: "",
            PC_VEN_NAME: "",
            PC_VEN_CODE: "",
            PC_VEN_CONTACT: "",
            PC_VEN_EMAIL: "",
            PC_VEN_ADD: "",
            PC_VEN_OPEN_BAL: "",

            addVendor: false
        };
        this.gridRef = React.createRef(null);
    }

    /* ── Working shop (Phase 2, 2026-11-02): a user with several shops picks it at the top. ── */
    ownId() {
        return this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id) }, () => this.getInventory());
    }

    async getInventory(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            SHOP_ID: this.ownId() || 0,
            PC_GRP_ID: OWN_KIND() === 'warehouse' ? '3' : '2',
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetVendors.php`, formData);
        console.log('getAllInventory', getAllInventory)
        let serviceData = getAllInventory.data
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            pagination.totalItems = parseInt(getAllInventory.data.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50);
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ InventoryList })
        this.props.toggleLoader(false)
    }

    hanldeAddVendor() {
        this.setState({
            addVendor: true
        })
    }


    async handleChangeInput(fieldName, evt) {
        let targetValue = evt.target.value
        this.setState({ [fieldName]: targetValue })
    }

    handleCancel() {
        this.setState({
            addVendor: false,
            PC_VEN_NAME: "",
            PC_VEN_CODE: "",
            PC_VEN_CONTACT: "",
            PC_VEN_EMAIL: "",
            PC_VEN_ADD: "",
            PC_VEN_OPEN_BAL: ""
        })

        this.getInventory();
    }


    handleValidate() {
        if (this.state.PC_VEN_NAME === "") {
            Swal.fire(
                'Error',
                "Enter Vendor Name",
                'error'
            )
            return false
        }

        if (this.state.PC_VEN_CODE === "") {
            Swal.fire(
                'Error',
                "Enter Vendor Code",
                'error'
            )
            return false
        }

        if (this.state.PC_VEN_CONTACT === "") {
            Swal.fire(
                'Error',
                "Enter Vendor Contact",
                'error'
            )
            return false
        }

        if (this.state.PC_VEN_EMAIL === "") {
            Swal.fire(
                'Error',
                "Enter Vendor Email",
                'error'
            )
            return false
        }

        if (this.state.PC_VEN_ADD === "") {
            Swal.fire(
                'Error',
                "Enter Vendor Address",
                'error'
            )
            return false
        }

        return true
    }

    async handleSubmit() {

        if (!this.handleValidate()) return

        let formData = {
            PC_VEN_ID: this.state.PC_VEN_ID,
            PC_VEN_NAME: this.state.PC_VEN_NAME,
            PC_VEN_CODE: this.state.PC_VEN_CODE,
            PC_VEN_CONTACT: this.state.PC_VEN_CONTACT,
            PC_VEN_EMAIL: this.state.PC_VEN_EMAIL,
            PC_VEN_ADD: this.state.PC_VEN_ADD,
            PC_VEN_OPEN_BAL: this.state.PC_VEN_OPEN_BAL || "0",
            PC_VEN_SHOP_ID: this.ownId() || 0,
            PC_GRP_ID: OWN_KIND() === 'warehouse' ? '3' : '2',
        }

        try {
            let getPurInvRes = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddShopVendor.php`, formData);
            if (getPurInvRes.data.status === 200) {
                Swal.fire(
                    'Success',
                    getPurInvRes.data.message,
                    'success'
                )
            } else {
                Swal.fire(
                    'Error',
                    getPurInvRes.data.message,
                    'error'
                )
            }
            this.handleCancel()
        } catch (error) {
            console.error('error :>> ', error);
        }

    }

    handleEdit(index) {
        // let { InventoryList } = this.state;
        // let filterInven = InventoryList[index]
    }

    render() {
        let { addVendor } = this.state;
        return (
            <Container>
                {addVendor === false ?
                    <>
                    <OwnEntityField compact kind={OWN_KIND()} screen={OWN_SCREEN} value={this.ownId()} onChange={this.handleOwnChange.bind(this)} />
                    <PhoneClinicGrid
                        title="VENDOR"
                        buttonLabel="ADD VENDOR"
                        onClickButton={this.hanldeAddVendor.bind(this)}
                        getData={this.getInventory.bind(this)}
                        isEditable={false}
                        ref={this.gridRef}
                        tableHeadData={[
                            {
                                label: "NAME",
                                isHidden: false
                            },
                            {
                                label: "VENDOR",
                                isHidden: false
                            },
                            {
                                label: "CONTACT",
                                isHidden: false
                            },
                            {
                                label: "EMAIL",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.InventoryList.map((service, idx) => (
                            <TableRow
                                className="table-rows"
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align='left' >{service.PC_VEN_NAME}</TableCell>
                                <TableCell align='left' >{service.PC_VEN_CODE}</TableCell>
                                <TableCell align='left' >{service.PC_VEN_CONTACT}</TableCell>
                                <TableCell align='left' >{service.PC_VEN_EMAIL}</TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    </>
                    :
                    <div>
                        <FormCard title="Add Vendor" mode="new"
                            onCancel={this.handleCancel.bind(this)}
                            onSave={this.handleSubmit.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Vendor Name</Form.Label>
                                    <Form.Control
                                        value={this.state.PC_VEN_NAME}
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Vendor Code</Form.Label>
                                    <Form.Control
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_CODE")}
                                        style={{ width: "100%" }}
                                        value={this.state.PC_VEN_CODE}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Contact</Form.Label>
                                    <Form.Control
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_CONTACT")}
                                        style={{ width: "100%" }}
                                        value={this.state.PC_VEN_CONTACT}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_EMAIL")}
                                        style={{ width: "100%" }}
                                        value={this.state.PC_VEN_EMAIL}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        value={this.state.PC_VEN_ADD}
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_ADD")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Opening Balance</Form.Label>
                                    <AmountInput
                                        value={this.state.PC_VEN_OPEN_BAL}
                                        //
                                        onChange={this.handleChangeInput.bind(this, "PC_VEN_OPEN_BAL")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </div>
                }
            </Container>
        );
    }
}

export default VendorSetup;